export default "__VITE_ASSET__b66b95e2__"